<template>
  <div>
    <Modal v-model="execModal" width="1000" title="作业执行控制台" footer-hide>
      <div style="min-height: 380px" id="job-exec-modal">
        <Row>
          <Col :xs="24" :sm="24" :md="24" :lg="8" style="border-right: 1px #e8eaec dashed; height: 380px">
            <div style="margin-bottom: 5px">
              <Row style="margin-bottom: 5px">
                <span>执行状态：</span>
                <span v-if="execLog.status === '队列中'">
                  <Icon type="md-clock" size="18" style="color: #2d8cf0" /><span style="color: #2d8cf0"> 队列中</span>
                </span>
                <span v-else-if="execLog.status === '完成'">
                  <Icon type="md-checkmark" size="18" style="color: #19be6b" /><span style="color: #19be6b"> 完成</span>
                </span>
                <span v-else-if="execLog.status === '执行中'">
                  <Icon type="ios-loading" size="18" style="color: #ff9900; animation: ani-demo-spin 1s linear infinite" />
                  <span style="color: #ff9900"> 执行中</span>
                </span>
                <span v-else-if="execLog.status === '暂停'">
                  <Icon type="ios-pause" size="18" style="color: #ff9900;" />
                  <span style="color: #ff9900"> 暂停</span>
                </span>
              </Row>
              <Button type="primary" :disabled="execLog.status !== '暂停'" @click="startExec(execLog.current_step)" size="small" style="margin-right: 5px; margin-bottom: 5px;">从当前步骤开始执行</Button>
              <Button type="primary" :disabled="execLog.status !== '暂停' || execLog.current_step + 1 > execLog.rough_step.length" @click="startExec(execLog.current_step + 1)" size="small" style="margin-right: 5px; margin-bottom: 5px;">执行下一步</Button>
              <Button type="error" :disabled="execLog.status !== '暂停'" @click="overJob" size="small" style="margin-right: 5px; margin-bottom: 5px;">结束作业</Button>
            </div>
            <Steps direction="vertical">
              <Step :title="'步骤' + item.serial" :content="item.name" v-for="(item, index) in execLog.rough_step" :key="'stepT_' + index" :status="item.status"></Step>
            </Steps>
          </Col>
          <Col :xs="24" :sm="24" :md="24" :lg="16">
            <div class="content">
              <div class="" style="padding-top: 0">
                <div v-if="!resultModel">
                  <Row class="title" >
                    <h4 :style="{float: 'left'}">执行日志</h4>
                    <a v-on:click="getLogData()" style="line-height: 32px; padding-left: 10px">
                      <Icon type="md-refresh" :class="{ 'demo-spin-icon-load': refreshing }" size="18"/>
                    </a>
                    <a style="float: right" v-on:click="resultModel = !resultModel">结果模式</a>
                  </Row>
                  <div v-if="execLog.content">
                    <GeminiScrollbar class="logs-scroll-bar">
                      <ul v-for="(content, tIndex) in execLog.content" :key="tIndex">
                        <li v-for="(console, eIndex) in content.console" :key="tIndex + '_' + eIndex">
                          <span>{{ console.time }} </span>
                          <span :style="{ color: console.color }"> {{ console.content }}</span>
                        </li>
                        <li v-if="tIndex < execLog.content.length - 1">==========================================================</li>
                      </ul>
                      <div style="color: #999" v-if="execLog.status === '执行中'">
                        <span v-if="$store.state.ws.socket.isConnected">
                          正在等待结果......
                        </span>
                        <span v-else>
                          正在等待结果...... 请手动点击<a v-on:click="getLogData()">刷新</a>
                        </span>
                      </div>
                    </GeminiScrollbar>
                  </div>
                </div>
                <div v-else>
                  <Row class="title">
                    <h4 :style="{float: 'left'}">执行结果</h4>
                    <a v-on:click="getLogData()" style="line-height: 32px; padding-left: 10px">
                      <Icon type="md-refresh" :class="{ 'demo-spin-icon-load': refreshing }" size="18"/>
                    </a>
                    <a style="float: right" v-on:click="resultModel = !resultModel">日志模式</a>
                  </Row>
                  <div v-if="execLog.content">
                    <GeminiScrollbar class="logs-scroll-bar">
                      <div v-for="(reContent, reIndex) in execLog.content" :key="reIndex">
                        <Alert>
                          <span class="span-dt" style="font-size: 15px">步骤 <b>{{ reContent.serial }}</b></span>
                          <json-viewer
                            :value="reContent.result"
                            :expand-depth="2"></json-viewer>
                        </Alert>
                      </div>
                    </GeminiScrollbar>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </Modal>
  </div>
</template>

<script>
import { execOpsCenterJob, detailOpsCenterJobExecLog, overOpsCenterJob } from '@/api/opscenter'
export default {
  name: 'job-exec-modal',
  data () {
    return {
      execModal: false,
      jobDataError: false,
      steps: [],
      logId: '',
      execLog: {},
      jobData: {},
      jobId: '',
      currentStep: '',
      refreshing: false,
      resultModel: false
    }
  },
  created: function () {
    this.listener()
  },
  methods: {
    // 打开执行模态框
    openExecModal (logId, jobId) {
      if (logId) {
        this.jobId = jobId
        this.logId = logId
        this.getLogData()
        this.execModal = true
      } else {
        this.$Notice.error({
          title: '获取该执行日志失败！'
        })
      }
    },
    // 获取日志信息
    getLogData () {
      if (this.logId) {
        this.refreshing = true
        detailOpsCenterJobExecLog(this.logId).then(res => {
          this.refreshing = false
          this.execLog = res.data
        }).catch(res => {
          this.refreshing = false
          this.$Notice.error({
            title: '获取执行日志失败！'
          })
        })
      }
    },
    // 执行
    startExec (step) {
      let reqData = {
        job: this.jobId,
        exec_log_id: this.logId,
        start_step: step
      }
      execOpsCenterJob(reqData).then(res => {
        this.getLogData()
        this.$emit('getExecLogsList')
        this.$Notice.success({ title: '操作成功，作业开始执行！' })
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '操作失败!',
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '操作失败！服务器无响应'
          })
        }
      })
    },
    // 结束作业
    overJob () {
      if (this.logId) {
        overOpsCenterJob({ exec_log_id: this.logId }).then(res => {
          this.$Notice.success({ title: '操作成功！' })
          this.$emit('getExecLogsList')
          this.getLogData()
        }).catch(res => {
          if (res.request) {
            this.$Notice.error({
              title: '操作失败!',
              desc: res.request.responseText
            })
          } else {
            this.$Notice.error({
              title: '操作失败！服务器无响应'
            })
          }
        })
      }
    },
    // 监听WS消息
    listener () {
      this.$options.sockets.onmessage = (data) => {
        const fData = JSON.parse(data.data)
        if (fData.group === 'message' && fData.service === 'opscenter' && fData.module === 'job') {
          if (fData.data) {
            if (fData.data.job_log_id === this.logId) {
              this.getLogData()
            }
          }
        }
        this.scrollToBottom()
      }
    },
    // 滚动条到最底部
    scrollToBottom () {
      setTimeout(() => {
        if (this.$refs.xwBody) {
          // 滚动条长度
          let currentDistance = this.$refs.xwBody.scrollHeight - this.$refs.xwBody.clientHeight
          // 当前滚动条距离顶部的距离
          let currentScrollY = this.$refs.xwBody.scrollTop
          if (currentDistance > 0 && currentDistance > currentScrollY) {
            currentScrollY = Math.ceil((currentDistance - currentScrollY) / 10) + currentScrollY
            currentScrollY = currentScrollY > currentDistance ? currentDistance : currentScrollY
            // 微信和qq浏览器不支持 scrollTo？
            // this.$refs.xwBody.scrollTo(0,currentScrollY);
            this.$refs.xwBody.scrollTop = currentScrollY
            this.scrollToBottom()
          }
        }
      }, 13)
    }
  }
}
</script>

<style lang="less" scoped>
  @import '../base.less';
  #job-exec-modal li {
    list-style-type: none;
  }
  #job-exec-modal li span {
    font-size: 14px;
  }
  .demo-spin-icon-load{
    animation: ani-demo-spin 1s linear infinite;
  }
  @keyframes ani-demo-spin {
    from { transform: rotate(0deg);}
    50%  { transform: rotate(180deg);}
    to   { transform: rotate(360deg);}
  }
  .logs-scroll-bar {
    height: 600px;
  }
  .jv-container.jv-light {
    background: none !important;
  }
</style>
